import './index.scss'
import img from '../../../../assets/main-page.png'
import bgImg from '../../../../assets/image 40.jpg'

import { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'

const FirstScreen = observer(() => {
  const [img1, setImg] = useState<any>(null)
  const [bg, setBg] = useState<any>(null)
  useEffect(() => {
    fetch(img)
      .then((fetchResponse) => {
        if (fetchResponse.ok) {
          return fetchResponse
        }
      })
      .then((response) => response!.blob())
      .then((imageBlob) => {
        const imageObjectURL: any = URL.createObjectURL(imageBlob)
        setImg(imageObjectURL)
      })
  }, [])

  useEffect(() => {
    fetch(bgImg)
      .then((fetchResponse) => {
        if (fetchResponse.ok) {
          return fetchResponse
        }
      })
      .then((response) => response!.blob())
      .then((imageBlob) => {
        const imageObjectURL: any = URL.createObjectURL(imageBlob)
        setBg(imageObjectURL)
      })
  }, [])
  if (!ContentState.home?.secondscreen) return <></>
  return (
    <section className="screen airplane section" id="airplane">
      <div className="screen__container">
        <div className="screen__row">
          <div
            className="screen__title"
            dangerouslySetInnerHTML={{
              __html: ContentState.home.secondscreen.title,
            }}
          ></div>
          <div className="screen__text">
            {ContentState.home.secondscreen.text}
          </div>
        </div>
        <div className="screen__bottom">
          <div className="screen__bottom-btns">
            <a
              href={ContentState.subMenu?.forbusinessLink}
              className="button  black mr29"
            >
              <span> {ContentState.home.buttonYou.title}</span>
            </a>
            <a className="button white" href={ContentState.subMenu?.foryouLink}>
              <span>{ContentState.home.buttonBusiness.title}</span>
            </a>
          </div>
        </div>
      </div>

      <div
        className="screen__bg"
        style={{ backgroundImage: `url(${bg})` }}
      ></div>
      {/* {img1} */}
      <div className="screen__airplane">{img1 && <img src="https://personal.nova.global/wp-content/uploads/2024/05/1.png" />}</div>
    </section>
  )
})

export default FirstScreen
